import React from 'react';
import { Question, Serializer } from 'survey-core';
import { ReactQuestionFactory, SurveyQuestionElementBase } from 'survey-react-ui';
import {
  Box, TextField, Typography,
} from '@mui/material';

const EIN_SOS_QUESTION_TYPE = 'ein-sos-verification';

interface EinSosValue {
  ein: string | null;
  sosCharterNumber: string | null;
}

class EinSosModel extends Question {
  getType () {
    return EIN_SOS_QUESTION_TYPE;
  }

  isEmpty (): boolean {
    return !this.value?.ein || !this.value?.sosCharterNumber;
  }
}

Serializer.addClass(
  EIN_SOS_QUESTION_TYPE,
  [],
  function () {
    return new EinSosModel('');
  },
  'question',
);

class EinSosQuestion extends SurveyQuestionElementBase {
  get question (): EinSosModel {
    return this.props.question;
  }

  get value (): EinSosValue {
    return this.question.value ?? {
      ein: null,
      sosCharterNumber: null,
    };
  }

  handleEinChange (ein: string) {
    this.question.value = {
      ...this.value,
      ein: ein || null,
    };
  }

  handleSosChange (sosCharterNumber: string) {
    this.question.value = {
      ...this.value,
      sosCharterNumber: sosCharterNumber || null,
    };
  }

  render () {
    return (
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
      >
        <Box>
          <Typography
            gutterBottom
            variant='subtitle2'
          >
            EIN (Employer Identification Number)
          </Typography>
          <TextField
            fullWidth
            disabled={this.question.isReadOnly}
            slotProps={{ input: { 'aria-label': 'EIN (Employer Identification Number)' } }}
            value={this.value.ein ?? ''}
            variant='outlined'
            onChange={(e) => this.handleEinChange(e.target.value)}
          />
        </Box>
        <Box>
          <Typography
            gutterBottom
            variant='subtitle2'
          >
            SOS Charter Number
          </Typography>
          <TextField
            fullWidth
            disabled={this.question.isReadOnly}
            slotProps={{ input: { 'aria-label': 'SOS Charter Number' } }}
            value={this.value.sosCharterNumber ?? ''}
            variant='outlined'
            onChange={(e) => this.handleSosChange(e.target.value)}
          />
        </Box>
      </Box>
    );
  }
}

export const registerEinSosQuestion = () => {
  ReactQuestionFactory.Instance.registerQuestion(
    EIN_SOS_QUESTION_TYPE,
    (props) => {
      return React.createElement(EinSosQuestion, props);
    },
  );
};
